import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { ModalDialog, ModalDialogMessages as sharedMsgs } from 'ecs-react-components/dist/index.es';

import AuthRepVerifyIdentityForm from '../../../containers/SignUp/AuthRepVerifyIdentity/AuthRepVerifyIdentityForm';
import { DedicatedWorkflowPanel } from '../../../components/SystemShared/DedicatedWorkflowPanel';
import { messages } from '../../../containers/SignUp/AuthRepVerifyIdentity/AuthRepVerifyIdentityForm.i18n';
import history from '../../../history';
import * as MsgBarActions from '../../../redux/modules/system-shared/message-bar-action-creator';

class AuthRepVerifyIdentityPage extends React.Component {
  constructor() {
    super();
    this.state = {
      isShowCancelModal: false,
      nextRoute: '',
    };
  }

  componentDidMount() {
    this.allowRouteToChange = false;

    if (this.props.history) {
      this.unblockRouter = this.props.history.block((next) => {
        let showCancelModal = true;
        if (next.pathname === '/create-account') {
          showCancelModal = false;
          this.allowRouteToChange = true;
        }

        if (!this.state.isShowCancelModal) {
          this.setState({
            isShowCancelModal: showCancelModal,
            nextRoute: next.pathname,
          });
        }

        return this.allowRouteToChange;
      });
    }
  }

  componentWillUnmount() {
    if (this.unblockRouter) {
      this.unblockRouter();
    }
  }

  setNoModalToRoute = () => {
    this.setState({
      isShowCancelModal: false,
    });

    this.allowRouteToChange = true;
  }

  hideCancelModal = () => {
    this.setState({
      isShowCancelModal: false,
    });

    this.allowRouteToChange = false;
    this.props.dispatch(MsgBarActions.dismissMessage());
    history.push('/auth-rep-sign-up' + location.search);
  }

  submitCancelModal = () => {
    this.setState({
      isShowCancelModal: false,
    });

    this.allowRouteToChange = true;
    history.push(this.state.nextRoute);
  }

  render() {
    return (
      <DedicatedWorkflowPanel headerTitle={ messages.page.title } instruction={ messages.page.instruction }>
        <AuthRepVerifyIdentityForm location={this.props.location} />
          <ModalDialog show={this.state.isShowCancelModal}
            title={sharedMsgs.cancelModal.title}
            message={sharedMsgs.cancelModal.message }
            submitBtnText={ sharedMsgs.cancelModal.submitBtnText }
            submitBtnTextDescription={ sharedMsgs.cancelModal.submitBtnTextDescription}
            hideBtnText={sharedMsgs.cancelModal.hideBtnText.button}
            hideBtnTextDescription={sharedMsgs.cancelModal.hideBtnText.description}
            onSubmit={this.submitCancelModal}
            onHide={this.hideCancelModal}
            id={1}
          />
      </DedicatedWorkflowPanel>
    );
  }
}


AuthRepVerifyIdentityPage.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  dispatch: PropTypes.func,
};

export default withRouter(connect()(AuthRepVerifyIdentityPage));